<template>
  <v-dialog
    v-model="updateRegistrationModel"
    persistent
    :maxWidth="`${(_getWindowWidth() > 600 ? 600 : _getWindowWidth()) * 0.8}px`"
    :fullscreen="_xsOnly()"
  >
    <v-card height="600">
      <v-row justify="start" class="ma-0 pa-0 pl-2 pt-2">
        <v-btn
          small
          @click="closeUpdateRegistrationModel()"
          text
          class="text-none primary--text"
          style="border: 0.5px solid rgba(242, 242, 242, 1)"
        >
          {{ _getLabel("CLOSE") }}
        </v-btn>
      </v-row>
      <v-row
        align="center"
        justify="center"
        class="vetalfa-big-title ma-0 pa-0 mt-5"
      >
        <v-col cols="10">
          <p class="ma-0 pa-0 text-center">
            {{ _getLabel("QUESTIONS_FIRST_TOPIC") }}
          </p>
        </v-col>
      </v-row>
      <v-card-text class="ma-0 pa-0 px-2 mt-4 white">
        <algorithms :headerHeightOffset="50"></algorithms>
        <v-row no-gutters class="white" style="height: 100px"></v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiChevronLeft } from "@mdi/js";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Algorithms from "@/algorithms/Algorithms.vue";
export default {
  data() {
    return {
      updateRegistrationModel: false,
      mdiChevronLeft,
    };
  },
  computed: {
    ...mapGetters("purchases", ["loading"]),
    ...mapGetters("general", ["user"]),
    ...mapGetters("algorithms", ["flowEndTrigger", "getModels"]),
  },
  props: {
    modelTrigger: { type: Boolean, default: false, required: true },
  },
  watch: {
    flowEndTrigger(val) {
      const routeName = this.$route.name;
      if (
        val &&
        !routeName.includes("registration") &&
        !routeName.includes("prescriptions") &&
        !routeName.includes("handouts") &&
        !routeName.includes("record") &&
        !routeName.includes("encounter")
      ) {
        this.saveUserNameCpfAndPurchasesOrder();
      }
    },
    modelTrigger: {
      handler: function (val) {
        if (val) {
          this.openAlgorithmsByModuleAndName({
            module: "users",
            name: "nationalityAlgorithm",
            children: ["displayNameAlgorithm"],
          });
        }
        this.updateRegistrationModel = val;
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    algorithms: Algorithms,
  },
  methods: {
    ...mapMutations("purchases", ["setPurchasesModel"]),
    ...mapActions("general", ["showAlert", "saveUserData", "setLoading"]),
    ...mapActions("algorithms", ["openAlgorithmsByModuleAndName"]),
    saveUserNameCpfAndPurchasesOrder: async function () {
      this.updateRegistrationModel = false;
      this.saveUserData({
        successCallback: this.successCallback,
      });
    },
    successCallback() {
      this.updateRegistrationModel = false;
      this.$emit("callbackUpdateRegistration");
    },
    closeUpdateRegistrationModel() {
      this.$emit("closeUpdateRegistrationModel");
      this.updateRegistrationModel = false;
    },
  },
  created() {},
};
</script>
